import { colors } from "colors";
import styled, { keyframes } from "styled-components";

export const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  min-height: 830px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

export const WeekNavigation = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  gap: 8px;
`;

export const DayButton = styled.button<{ selected: boolean }>`
  flex: 1;
  padding: 12px;
  background-color: ${({ selected }) => (selected ? colors.mainGreen + '20' : '#ffffff')};
  cursor: pointer;
  border: 1px solid ${({ selected }) => (selected ? colors.mainGreen : '#eaeaea')};
  border-radius: 8px;
  transition: all 0.2s ease;
  font-weight: ${({ selected }) => (selected ? '600' : '400')};
  color: ${({ selected }) => (selected ? colors.mainGreen : colors.black)};
  
  &:hover {
    background-color: ${({ selected }) => (selected ? colors.mainGreen + '20' : '#f8f8f8')};
    border-color: ${({ selected }) => (selected ? colors.mainGreen : '#e0e0e0')};
  }
`;

export const CallsContainer = styled.div`
  padding: 20px 0;
  border-top: 1px solid #eaeaea;
  overflow-y: auto;
  max-height: 100%;
  
  .checkmark {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.mainGreen};
    border-radius: 6px;
    margin-right: 16px;
    color: white;
    transition: all 0.2s ease;
    cursor: pointer;
    
    &:hover {
      transform: scale(1.05);
    }
  }

  .dropdown-wrapper {
    margin-right: 20px;
    width: 250px;
    
    select {
      width: 100%;
      padding: 8px 12px;
      border-radius: 6px;
      border: 1px solid #eaeaea;
      background-color: white;
      color: ${colors.black};
      font-size: 14px;
      transition: all 0.2s ease;
      cursor: pointer;
      
      &:hover {
        border-color: ${colors.mainGreen};
      }
      
      &:focus {
        outline: none;
        border-color: ${colors.mainGreen};
        box-shadow: 0 0 0 2px ${colors.mainGreen}20;
      }
    }
  }
`;

export const CallItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  margin-bottom: 12px;
  background-color: white;
  border-radius: 10px;
  border: 1px solid #eaeaea;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border-color: ${colors.mainGreen}40;
  }

  .deal-details {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .switch-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${colors.black};
    opacity: 1;
    transition: opacity 0.2s ease;

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
`;

export const Time = styled.div`
  width: 100px;
  color: ${colors.black};
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CallInfo = styled.div`
  flex: 1;
  color: ${colors.black};
  
  .meeting-title {
    font-weight: 600;
    margin-bottom: 4px;
    font-size: 15px;
  }
  
  .meeting-subtitle {
    color: #666;
    font-size: 13px;
    display: flex;
    align-items: center;
    position: relative;

    .attendees-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 300px;
      cursor: pointer;

      &:hover + .tooltip {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  .tooltip {
    position: absolute;
    bottom: calc(100% + 5px);
    left: 0;
    background-color: #2d3748;
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 12px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
    z-index: 1000;
    white-space: normal;
    max-width: 400px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    word-wrap: break-word;

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 20px;
      border-width: 5px;
      border-style: solid;
      border-color: #2d3748 transparent transparent transparent;
    }
  }
  
  .no-meetings {
    font-size: 16px;
    color: #666;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const Host = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.black};
  width: 20%;
  justify-content: flex-end;
  gap: 12px;
  
  p {
    font-size: 14px;
    color: #666;
  }
`;

export const HostInitial = styled.div`
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  background-color: ${colors.mainGreen};
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
`;

export const WeekToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 16px;
  
  .week-title {
    font-size: 20px;
    font-weight: 600;
    color: ${colors.goodBlack};
  }
`;

export const ToggleButton = styled.button`
  background: none;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  svg {
    width: 20px;
    height: 20px;
    color: ${colors.goodBlack};
  }
  
  &.right svg {
    transform: rotate(180deg);
  }
`;

const skeletonLoading = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`;

export const CalendarLoader = styled.div`
  width: 100%;
  margin-top: 25px;
  margin-bottom: 55px;
  height: 800px;
  background: linear-gradient(90deg, #f7f7f7 25%, #ededed 50%, #f7f7f7 75%);
  animation: ${skeletonLoading} 3s infinite linear;
  background-size: 200% 100%;
  border-radius: 12px;
`;
